export default {
  categories: 'Categories',
  city: 'Category',
  add: 'Add category',
  update: 'Update category',
  details: 'category details'
}
